import { Box, FormControl, FormHelperText, MenuItem, Typography } from '@mui/material'
import { SelectChangeEvent } from '@mui/material'
import { SelectLanguage } from '../../../../../shared/styles/HelpCenterStyles'

interface TopicSelectorProps {
  topics: Array<{ id: number; name: string }>
  selectedTopic: number | null
  onChange: (event: SelectChangeEvent<unknown>) => void
  errorMessage?: string
  label: string
}

const TopicSelector = ({ topics, selectedTopic, onChange, errorMessage, label }: TopicSelectorProps) => {
  return (
    <>
      <Box mb={0.5}>
        <Typography>{label}</Typography>
      </Box>
      <FormControl fullWidth>
        <SelectLanguage labelId="topic-select-label" id="topic-select" value={selectedTopic} onChange={onChange}>
          {topics.map(topic => (
            <MenuItem
              key={`${topic.id}-${topic.name}`}
              value={topic.id}
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
            >
              {topic.name.toUpperCase()}
            </MenuItem>
          ))}
        </SelectLanguage>
        <FormHelperText error id="topic-helper-text">
          {errorMessage}
        </FormHelperText>
      </FormControl>
    </>
  )
}

export default TopicSelector
